import type { ReasoningSupport } from "../model-parameters.ts";
import type { BedrockOffering } from "./offerings.ts";

/**
 * Per offering key, the exceptions to what the catalogue sync generates and the family rules
 * derive (model-picking D3, slice 4b). Only exceptions: every entry names a generated key (the
 * drift test checks it), and an entry is reviewed like any catalogue change.
 *
 * - `price` with `priceDivergence`: ESI's negotiated or realigned rate for a route, with the
 *   reason and upstream's value of each field that differs (the drift check compares both).
 * - `reasoning`: a style the family rule does not give (e.g. a version that takes a thinking
 *   budget although its family is adaptive from an older version). Claude Haiku 4.5's `budget`
 *   needs none: adaptive reasoning is the family rules' opt-in (`adaptiveReasoningFrom`).
 * - `retired: true`: ADR 0017 §1's "retire older ones", by hand. A retired key stays known for
 *   stored values (consents, `models.allowedModels`, usage) and is never a candidate.
 */
export interface OfferingOverride {
  readonly reasoning?: ReasoningSupport | null;
  readonly price?: BedrockOffering["price"];
  readonly priceDivergence?: NonNullable<BedrockOffering["priceDivergence"]>;
  readonly retired?: true;
}

export const OFFERING_OVERRIDES: Readonly<Record<string, OfferingOverride | undefined>> = {};
